import getQueryVariable from '@common/getQueryVariable';

const envt = () => {
  let env = '';
  // uat环境
  if (window.location.href.indexOf('isuat=true') !== -1) {
    env = 'uat-';
  }
  // 预发环境
  if (window.location.href.indexOf('ispre=true') !== -1) {
    env = 'pre-';
  }
  return env;
};
export const APIHost = `https://${envt()}api.bilibili.com`;
// export const useMock = true
export const useMock = false;
export const jsonUrl = `https://activity.hdslb.com/blackboard/static/jsonlist/255/p8lCqAGgXs.json?t=${Math.floor(
    Date.now() / (60 * 1000)
)}`;
// export const bgKVOpen = 'https://activity.hdslb.com/blackboard/static/40dde83b177aaa15ed63fe49a5b497a7/oh0246wz5A.mp4'
export const bgKVLoop =
  'https://activity.hdslb.com/blackboard/static/20210728/70bb422013eb4692db31a31f5240742d/R9k3XQ9Q2V.mp4';
export const bgKV =
  // '//activity.hdslb.com/blackboard/static/20220907/e0d3f10e7ac18c8e4058e769fd6fe541/Y8P2A3mb0z.mov';
  'https://activity.hdslb.com/blackboard/static/20230912/ed208e0685394224eb0049ea11d67202/AnLh8JwRwu.mp4';
// export const bgKVLoop = 'https://activity.hdslb.com/blackboard/static/20210924/fbb6ffcfd09815bd66290b6b7bde1196/eKWuIw27OV.mp4'
export const unloginAvatarUrl =
  'https://i0.hdslb.com/bfs/activity-plat/static/20210929/6a806a6a097a741ff3b5beac907646e3/zcF178Kpgb.jpg';
// export const staticText = [ '此数值仅预估视频投稿收益，该预估数值未经风控核验，仅做参考；数值预计每日19时更新，若当日计算量较大，数值会出现延迟更新。',
//   '此数值仅预估视频投稿收益，该预估数值未经风控核验，仅做参考；数值预计每日19时更新，若当日计算量较大，数值会出现延迟更新。', '此数值仅预估视频投稿收益，该预估数值未经风控核验，仅做参考；数值预计每日19时更新，若当日计算量较大，数值会出现延迟更新。' ]
export const staticText = [
  '此数据仅核算视频投稿收益，数值每日19时更新。该数值仅做参考，请以最终发奖金额为准。',
  '此数据仅核算视频投稿收益，数值每日19时更新。该数值仅做参考，请以最终发奖金额为准。',
  '此数据仅核算视频投稿收益，数值每日19时更新。该数值仅做参考，请以最终发奖金额为准。',
  '此数据仅核算视频投稿收益，数值每日19时更新。该数值仅做参考，请以最终发奖金额为准。',
  '活动已结束，此数据仅核算视频投稿收益，数值仅做参考，请以最终发奖金额为准。',
  ''
];
// export const dayRankID = envt() === 'uat-' ? 185 : 187;
// export const totalRankID = envt() === 'uat-' ? 186 : 188;
export const dayRankID = envt() === 'uat-' ? 187 : 187;
export const totalRankID = envt() === 'uat-' ? 188 : 188;

// export const h5RankNo = [
//   'https://i0.hdslb.com/bfs/activity-plat/static/20230910/ed208e0685394224eb0049ea11d67202/15HMOOmYEH.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/XWp6yArVJQ.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/gB62BQhBbC.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/XdRdvRlWHN.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/D3l2lQRts1.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/5qwXyGbQEY.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/N94WmA7ENy.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/0mvkmSXDq4.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/o1qoCzV92z.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/eOjqP9qQuU.png'

// ]
export const h5RankNo = [
  '//i0.hdslb.com/bfs/activity-plat/static/20230910/ed208e0685394224eb0049ea11d67202/15HMOOmYEH.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230911/ed208e0685394224eb0049ea11d67202/GCJCuVE5Mh.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230911/ed208e0685394224eb0049ea11d67202/Uw12UMkUCN.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230911/ed208e0685394224eb0049ea11d67202/pOiV7ATeh6.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230911/ed208e0685394224eb0049ea11d67202/5yNfAcnTy8.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230911/ed208e0685394224eb0049ea11d67202/VyqwdN7TWY.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230911/ed208e0685394224eb0049ea11d67202/I8kKWvgLct.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230911/ed208e0685394224eb0049ea11d67202/Jjvuezx2Mr.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230911/ed208e0685394224eb0049ea11d67202/Tci16Tzzng.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230911/ed208e0685394224eb0049ea11d67202/lek1kX5S69.png',
];

// export const pcRankNo = [
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/7RV5bew0px.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/tGSX4jlCLR.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/31NYOHriwp.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/PRhzydVqXL.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/cPoD84q23T.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/TCFuiabD4P.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/i1VeBhSwpW.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/fyWrLdD7uy.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/eSp3bIJHho.png',
//   'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/keL7z0CQbE.png',
// ];
export const pcRankNo = [
  '//i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/NOa6eh1pJL.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/5gP9HMhOBp.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/SC6cIwQqKW.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/sLlNkII9U3.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/IBR4WehIWp.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/MhcM7CdHym.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/cKXXUA3Vtn.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/fvFFzm7h4v.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/JCThYMqufV.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/cgfsN7JW4L.png',
];

// export const pcRankNumber = [
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/eKAJkUDYE7.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/oVJU9eYOI2.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/9O0Hb7CpiQ.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/s4T47ISZvs.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/OGdwHBWjU5.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/vLw5eIXhK7.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/ig3QeTKKbq.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/3T7oeHqsld.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/qOqq1VRf2Z.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20230912/ed208e0685394224eb0049ea11d67202/y2HU140A6Z.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/iezot8pKL9.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/7VdkOY7cb4.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/RvnBz9fm2E.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/2MvpwYPMKa.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/92LQ2NB9OF.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/Um1GzAYjHv.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/YonJlztkh0.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/e7dAfhUT3G.png',
//   // 'https://i0.hdslb.com/bfs/activity-plat/static/20220830/53704fc8d3ac45ac4b9a45153a694277/Egloel7pfG.png',
// ];
export const pcRankNumber = [
  '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/7czM8f17cw.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/4MH0GhzQuQ.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/s95l4uwzbO.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/JQrBLUjVyF.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/a4aOFTuJ00.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/2XN1Wm0IB0.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/wxgfw1WQxw.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/o5UD6ibgUQ.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/D3JZ3IGxEo.png',
  '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/18tCdYV1na.png',

  // '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/18tCdYV1na.png',
  // '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/D3JZ3IGxEo.png',
  // '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/o5UD6ibgUQ.png',
  // '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/wxgfw1WQxw.png',
  // '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/2XN1Wm0IB0.png',
  // '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/a4aOFTuJ00.png',
  // '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/JQrBLUjVyF.png',
  // '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/s95l4uwzbO.png',
  // '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/4MH0GhzQuQ.png',
  // '//i0.hdslb.com/bfs/activity-plat/static/20230914/ed208e0685394224eb0049ea11d67202/7czM8f17cw.png',
]